import { render } from "./icon-cog-alt.vue?vue&type=template&id=13f3ca54"
const script = {}

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__